import React, { useState } from 'react'
import { useFetchPriceTablesQuery } from 'features/private-views/settings/PriceTable/priceTableApiSlice'
import { ChevronDown, ChevronUp } from 'react-feather'

const PriceReference = ({ itemId, onUsePrice, currentPrice, currentUnit }) => {
  const { data, isFetching } = useFetchPriceTablesQuery(
    { itemId, page: 0, size: 100 },
    { skip: !itemId }
  )
  const [isOpen, setIsOpen] = useState(false)

  const items = data?.items || []
  const visibleItems = isOpen ? items : items.slice(0, 2)
  const hasMore = items.length > 2

  if (isFetching) {
    return <div className="text-muted small mt-1">Mengecek tabel harga...</div>
  }

  if (items.length === 0) {
    return null
  }

  return (
    <div className="mt-1" data-testid="sell-form-price-reference-button">
      <div className="text-muted small fw-semibold mb-1">Tabel Harga:</div>
      <div className="d-flex flex-wrap gap-2 pb-1 align-items-center">
        {visibleItems.map((item) => {
          const isUsed =
            currentPrice !== undefined &&
            currentPrice !== null &&
            currentPrice !== '' &&
            Number(currentPrice) === Number(item.price) &&
            (!currentUnit ||
              String(currentUnit).toLowerCase() === String(item.unit).toLowerCase())

          return (
            <div key={item.id} className="d-flex align-items-center bg-light px-2 py-1 rounded border flex-shrink-0">
              <span className="text-muted small me-2">
                {item.unit}: Rp {new Intl.NumberFormat('id-ID').format(item.price)}
              </span>
              <span
                className={isUsed ? "text-muted small fw-semibold" : "text-primary small fw-semibold text-decoration-underline"}
                style={{ cursor: isUsed ? 'not-allowed' : 'pointer' }}
                onClick={isUsed ? undefined : () => onUsePrice(item.price, item.unit)}
              >
                Gunakan
              </span>
            </div>
          )
        })}
        {hasMore && (
          <div
            className="d-flex align-items-center text-primary small fw-semibold ms-1"
            style={{ cursor: 'pointer' }}
            onClick={() => setIsOpen(!isOpen)}
          >
            {isOpen ? 'Lebih sedikit' : `+${items.length - 2} lainnya`}
            {isOpen ? <ChevronUp size={14} className="ms-1" /> : <ChevronDown size={14} className="ms-1" />}
          </div>
        )}
      </div>
    </div>
  )
}

export default PriceReference
